// extracted by mini-css-extract-plugin
export var backupIcon = "_nx-1";
export var image = "_nx-0";